import React, {memo, useMemo} from "react";
import {Document, Font, Image, Page, pdf, StyleSheet, Text} from "@react-pdf/renderer";

// Storage rasm pathlarini olish funksiyasi
const getStorageImagePaths = (storageNumber) => {
    const baseUrl = process.env.REACT_APP_API_URL;
    let block, section;

    const num = Number(storageNumber);
    if (num >= 1 && num <= 10) {
        block = 1; section = 1;
    } else if (num >= 11 && num <= 19) {
        block = 2; section = 1;
    } else if (num >= 20 && num <= 28) {
        block = 2; section = 2;
    } else if (num >= 29 && num <= 37) {
        block = 3; section = 1;
    } else if (num >= 38 && num <= 46) {
        block = 3; section = 2;
    } else if (num >= 47 && num <= 55) {
        block = 4; section = 1;
    } else if (num >= 56 && num <= 60) {
        block = 4; section = 2;
    } else {
        block = 1; section = 1;
    }

    return {
        page1: `${baseUrl}/apartment_images/${block}-block-schema-storage/1-1-${section}.png`,
        page2: `${baseUrl}/apartment_images/${block}-block-schema-storage/2-1-${section}.png`,
    };
};

Font.register({
    family: "Roboto",
    fonts: [
        {
            src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-regular-webfont.ttf",
            fontWeight: "normal",
        },
        {
            src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf",
            fontWeight: "bold",
        },
    ],
});

const styles = StyleSheet.create({
    page: {
        padding: 20,
        fontFamily: "Roboto",
        fontSize: 10,
        backgroundColor: "#ffffff",
        position: "relative",
    },
    pageBackground: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "#ffffff",
        objectFit: "cover",
        zIndex: -1,
    },
    block: {
        position: "absolute",
        top: 65,
        left: '43%',
        fontWeight: "bold"
    },
    client: {
        position: "absolute",
        top: "68%",
        left: '20%',
        fontWeight: "bold",
        fontSize: '9px',
        width: '190px'
    },
    userName: {
        position: "absolute",
        top: "71.5%",
        left: '23%',
        fontWeight: "bold",
        fontSize: '9px',
        width: '170px',
    },
    phone: {
        position: "absolute",
        top: "75%",
        left: '27%',
        fontWeight: "bold",
        fontSize: '9px',
        width: '150px',
    },
});

const StoragePDFDocument = memo(({
                                     storage = {},
                                     order = null,
                                     userData = null,
                                     rate,
                                     user = {}
                                 }) => {
    const clientName = useMemo(() => userData?.customerName || order?.client?.customerName || "", [userData?.customerName, order?.client?.customerName]);
    const imagePaths = useMemo(() => getStorageImagePaths(storage?.number), [storage?.number]);

    return (
        <Document>
            {/* Page 1 */}
            <Page size="A4" style={styles.page}>
                <Text style={styles.block}>{storage.block || "..."}</Text>
                <Text style={styles.client}>{clientName || "..."}</Text>
                <Text style={styles.userName}>{user?.username || "..."}</Text>
                <Text style={styles.phone}>{user?.phone || "..."}</Text>
                <Image src={imagePaths.page1} style={styles.pageBackground}/>
            </Page>

            {/* Page 2 */}
            <Page size="A4" style={styles.page}>
                <Text style={styles.block}>{storage.block || "..."}</Text>
                <Image src={imagePaths.page2} style={styles.pageBackground}/>
            </Page>
        </Document>
    );
});

export const generateStoragePDFBlob = async (props) => {
    return await pdf(<StoragePDFDocument {...props} />).toBlob();
};

export const generateStoragePDFUrl = async (props) => {
    const blob = await pdf(<StoragePDFDocument {...props} />).toBlob();
    return URL.createObjectURL(blob);
};

export const downloadStoragePDF = async (props, fileName = "storage.pdf") => {
    const blob = await pdf(<StoragePDFDocument {...props} />).toBlob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};

export default StoragePDFDocument;